/**
 * Shared attributes for UI preference cookies (`gail_lang`, `gail_theme`).
 *
 * These are host-only (no `Domain`) so they stay on the UI origin and are
 * not sent to Galactus (`NEXT_PUBLIC_GAIL_API` / api.meetgail.com). Same-origin
 * Next `/api/*` may still receive them under Path=/ — that is accepted.
 *
 * Always Secure: the site is HSTS (including local development).
 * Not HttpOnly: client JS and the head migration script must read them.
 */
export const PREFERENCE_COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 365;

/**
 * Cookie attribute suffix for preference cookies. Never includes `Domain`
 * (host-only). Always includes `Secure`.
 */
export const getPreferenceCookieAttributes = (): string =>
  `Path=/; Max-Age=${PREFERENCE_COOKIE_MAX_AGE_SECONDS}; SameSite=Lax; Secure`;

/**
 * Full `document.cookie` assignment string for a preference cookie.
 */
export const buildPreferenceCookieWrite = (
  name: string,
  value: string
): string =>
  `${name}=${encodeURIComponent(value)}; ${getPreferenceCookieAttributes()}`;
